/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Empty_BodyInputs */

const en_us2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two photos, front and side, turn into a waist-to-height ratio and a body-fat estimate.`)
};

const pt_br2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas fotos, de frente e de lado, viram uma relação cintura/altura e uma estimativa de gordura corporal.`)
};

const es_419_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dos fotos, de frente y de lado, se convierten en una relación cintura/estatura y una estimación de grasa corporal.`)
};

const pt_pt2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duas fotos, de frente e de lado, tornam-se uma relação cintura/altura e uma estimativa de gordura corporal.`)
};

const fr_fr2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deux photos, de face et de profil, donnent un rapport tour de taille/taille et une estimation de masse grasse.`)
};

const de_de2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus zwei Fotos, von vorne und von der Seite, werden ein Taille-Größe-Verhältnis und eine Körperfettschätzung.`)
};

const it_it2_body_assessment_empty_body = /** @type {(inputs: Body_Assessment_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due foto, frontale e laterale, diventano un rapporto vita/altezza e una stima del grasso corporeo.`)
};

/**
* | output |
* | --- |
* | "Two photos, front and side, turn into a waist-to-height ratio and a body-fat estimate." |
*
* @param {Body_Assessment_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_empty_body = /** @type {((inputs?: Body_Assessment_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_empty_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_empty_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_empty_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_empty_body(inputs)
	return en_us2_body_assessment_empty_body(inputs)
});
export { body_assessment_empty_body as "body-assessment.empty_body" }